
export function populateFormDataFromListing(listing) {
  console.log('listing', listing)
  let formData = {
    id: listing._id,
    userId: listing.userId,
    listingName: listing.listingName,
    address1: listing.address.address1,
    address2: listing.address.address2,
    zip: listing.address.zip,
    city: listing.address.city,
    state: listing.address.state,
    geometry: {
      lat: listing.geometry.coordinates[1],
      lng: listing.geometry.coordinates[0]
    },
    tags: listing.tags,
    houseType: listing.houseType,
    bedrooms: listing.bedrooms,
    sleeps: listing.sleeps,
    bathrooms: listing.bathrooms,
    about: listing.listingDetails.about,
    sleepingArrangements: listing.listingDetails.sleepingArrangements,
    petsAllowed: listing.listingDetails.petsAllowed,
    smokingAllowed: listing.listingDetails.smokingAllowed,
    amenities: listing.amenities,
    photos: listing.photos,
    pricing: {
      ...listing.pricing,
      extended_fee: {
        ...listing.pricing.extended_fee,
        enabled: !!listing.pricing.extended_fee && !!listing.pricing.extended_fee.from && !!listing.pricing.extended_fee.to
      },
      weekend_fee: {
        ...listing.pricing.weekend_fee,
        enabled: !!listing.pricing.weekend_fee && !!listing.pricing.weekend_fee.from && !!listing.pricing.weekend_fee.to
      }
    },
    addOns: listing.addOns,
    discounts: listing.discounts,
    calendars: listing.calendars,
    bookingSetting: listing.bookingSetting,
    isActive: listing.isActive,
    isFeatured: listing.isFeatured,
    lastCompleted: listing.lastCompleted
  };
  formData.pricing.localTaxDecimal = (formData.pricing.localTax * 100).toFixed(2);
  formData.pricing.stateTaxDecimal = (formData.pricing.stateTax * 100).toFixed(2);

  return formData;
}

export function populateListingFromFormData(formData) {
  let listing = {
    _id: formData.id,
    userId: formData.userId,
    listingName: formData.listingName,
    address: {
      address1: formData.address1,
      address2: formData.address2,
      zip: formData.zip,
      city: formData.city,
      state: formData.state
    },
    geometry: {
      type: 'Point',
      coordinates: [formData.geometry.lng, formData.geometry.lat],
    },
    houseType: formData.houseType,
    bedrooms: formData.bedrooms,
    sleeps: formData.sleeps,
    bathrooms: formData.bathrooms,
    tags: formData.tags,
    listingDetails: {
      about: formData.about,
      sleepingArrangements: formData.sleepingArrangements,
      petsAllowed: formData.petsAllowed,
      smokingAllowed: formData.smokingAllowed
    },
    amenities: formData.amenities,
    photos: formData.photos,
    pricing: formData.pricing,
    addOns: formData.addOns,
    discounts: formData.discounts,
    calendars: formData.calendars,
    bookingSetting: formData.bookingSetting,
    isActive: formData.isActive,
    isFeatured: formData.isFeatured,
    lastCompleted: formData.lastCompleted,
  };
  if (listing.pricing.localTaxDecimal) listing.pricing.localTax = (listing.pricing.localTaxDecimal / 100).toFixed(4);
  if (listing.pricing.stateTaxDecimal) listing.pricing.stateTax = (listing.pricing.stateTaxDecimal / 100).toFixed(4);

  return listing;
}
